// Stock placeholder images keyed by category. Used by EntryAvatar when
// an entry has no image_url set — gives the site a thematic look while
// the admin is still filling in real logos/photos.
//
// Each category exposes a small pool of tiles; we pick
// deterministically from the pool using a hash of the entry id so the
// same entry always shows the same placeholder.

// patch 30: own pixel-art tiles (160 px WebP, ~4 KB) instead of 400 px photos from images.unsplash.com
const tiles = (cat) => [1, 2, 3, 4].map((i) => `/placeholders/${cat}-${i}.webp`);
const POOL = {
  stores: tiles("stores"),
  vending: tiles("vending"),
  events: tiles("events"),
  creators: tiles("creators"),
};

function hash(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getCategoryPlaceholder(category, seed = "") {
  const pool = POOL[category] || POOL.stores;
  const idx = hash(seed) % pool.length;
  return pool[idx];
}

/** Return the entry's real image_url if present, else a thematic placeholder. */
export function entryImage(entry) {
  if (!entry) return "";
  if (entry.image_url) return entry.image_url;
  return getCategoryPlaceholder(entry.category, entry.id || entry.name || "");
}
